<div class="row">
    <div class="col-span-12 col-md-3">
      <p-datepicker [(ngModel)]="period" [showIcon]="true" dateFormat="dd.mm.yy" (onSelect)="showData()"/>
    </div>
    
</div>

<p-chart type="bar" [data]="data" [options]="options" *ngIf="data"></p-chart>

<div [ngStyle]="{'text-align': 'center'}">
  <p-progressSpinner *ngIf="dataLoading" styleClass="w-16 h-16" strokeWidth="6" fill="var(--surface-ground)" animationDuration="4s"></p-progressSpinner>
</div>


<div>&nbsp;</div>
<h3 *ngIf="!data && !dataLoading">Нет данных за период</h3>